import React, { Component, useEffect, useState } from "react";
import i18n from "i18next";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { IFetchWrapperResultDto } from "../../../Models/IFetchWrapperResultDto";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { DismissRegular, FolderPersonRegular } from "@fluentui/react-icons";
import {
  MessageBar,
  Button,
  MessageBarActions,
} from "@fluentui/react-components";
import { UserDocumentsColumns } from "./UserDocumentsColumns";
import { IUserDocument } from "../../../Models/IUserDocument";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import DialogDeleteUserDocument from "./DialogDeleteUserDocument";
import Header from "../../Layout/Header";

function UserDocuments() {
  // UseStates
  //Temp Guid
  const [selectedGuid, setSelectedGuid] = useState<string | undefined>(
    undefined,
  );
  const [hoveredGuid, setHoveredGuid] = useState<string>("");
  const [wrapperResult, setWrapperResult] = useState<
    IFetchWrapperResultDto | undefined
  >(undefined);
  const [userDocuments, setUserDocuments] = useState<IUserDocument[]>([]);

  useEffect(() => {
    getuserDocuments();
  }, []);

  const getuserDocuments = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/vertrieb/GetUserDocuments`)
      .then((result) => {
        setUserDocuments(result);
      })
      .catch((error) => {});
  };

  const changeUserDocumentFilename = (guid: string, newFilename: string) => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/vertrieb/ChangeUserDocumentFilename?guid=${guid}&newFilename=${newFilename}`,
      )
      .then((fetchwrapperResult: IFetchWrapperResultDto | undefined) => {
        setWrapperResult(fetchwrapperResult);

        if (fetchwrapperResult?.statusCode == 4) {
          getuserDocuments();
        } else if (fetchwrapperResult?.statusCode == 2) {
        }
      })
      .catch((error) => {});
  };

  const changeUserDocumentDescription = (
    guid: string,
    newDescription: string,
  ) => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/vertrieb/changeUserDocumentDescription?guid=${guid}&newDescription=${newDescription}`,
      )
      .then((fetchwrapperResult: IFetchWrapperResultDto | undefined) => {
        setWrapperResult(fetchwrapperResult);
        if (fetchwrapperResult?.statusCode == 4) {
          getuserDocuments();
        } else if (fetchwrapperResult?.statusCode == 2) {
        }
      })
      .catch((error) => {});
  };
  const deleteUserDocument = (guid: string) => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/vertrieb/DeleteUserDocument?guid=${guid}`)
      .then((fetchWrapperResult: IFetchWrapperResultDto | undefined) => {
        setWrapperResult(fetchWrapperResult);
        setSelectedGuid(undefined);
        getuserDocuments();
      });
  };
  const columns = UserDocumentsColumns({
    openDeleteDialog: (item: string) => {
      setSelectedGuid(item);
    },
    hoveredRowGuid: hoveredGuid,
    selectedDocumentToDelete: () => {},
    onChangeFileName: (oldFilenameWithExtension, newFilenameWithExtension) => {
      changeUserDocumentFilename(
        oldFilenameWithExtension,
        newFilenameWithExtension,
      );
    },
    onChangeDescription(guid, newDescription) {
      changeUserDocumentDescription(guid, newDescription);
    },
  });

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<FolderPersonRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
            >
              {i18n.t<string>("userDocuments").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        {wrapperResult != undefined && (
          <MessageBar
            intent={
              wrapperResult.statusCode == 1
                ? "error"
                : wrapperResult.statusCode == 4
                ? "success"
                : wrapperResult.statusCode == 5
                ? "warning"
                : "info"
            }
          >
            {i18n.t<string>(wrapperResult.message)}
            <MessageBarActions
              containerAction={
                <Button
                  onClick={() => {
                    setWrapperResult(undefined);
                  }}
                  appearance="transparent"
                  icon={<DismissRegular />}
                />
              }
            />
          </MessageBar>
        )}

        <DialogDeleteUserDocument
          onDelete={() => {
            if (selectedGuid) {
              deleteUserDocument(selectedGuid);
            }
          }}
          onClose={() => {
            setSelectedGuid(undefined);
          }}
          open={selectedGuid != undefined}
        />

        <LuebPagedDataGrid
          sortable
          columns={columns}
          items={userDocuments}
          resizableColumns={true}
          columnSizingOptions={{
            docFileExtension: { minWidth: 50, defaultWidth: 70 },
            docFileName: { minWidth: 350, defaultWidth: 570 },
            "createdBy.fullName": { miWidth: 100, defaultWidth: 150 },
          }}
        />
      </div>
    </div>
  );
}

export default UserDocuments;
